"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get getModelSchemas () {
        return getModelSchemas;
    },
    get getViewSchemas () {
        return getViewSchemas;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _stringHelpers = require("~/helpers/stringHelpers");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
const getModelSchemas = (ctx)=>{
    var _ctx_columns, _ctx_columns1, _ctx_columns2;
    return {
        [`${(0, _stringHelpers.swaggerSanitizeSchemaName)(ctx.tableName)}Response`]: {
            title: `${ctx.tableName} Response`,
            type: 'object',
            description: '',
            'x-internal': false,
            properties: {
                id: {
                    oneOf: [
                        {
                            type: 'string'
                        },
                        {
                            type: 'number'
                        }
                    ],
                    description: 'Record identifier (primary key value)'
                },
                fields: {
                    type: 'object',
                    description: 'Record fields data (excluding primary key)',
                    properties: _extends({}, ((_ctx_columns = ctx.columns) == null ? void 0 : _ctx_columns.reduce((colsObj, _1)=>{
                        let { title, virtual, column } = _1, fieldProps = _object_without_properties_loose(_1, [
                            "title",
                            "virtual",
                            "column"
                        ]);
                        return _extends({}, colsObj, (0, _nocodbsdk.isSystemColumn)(column) || column.pk ? {} : {
                            [title]: fieldProps
                        });
                    }, {})) || {})
                }
            },
            required: [
                'id'
            ]
        },
        [`${(0, _stringHelpers.swaggerSanitizeSchemaName)(ctx.tableName)}Request`]: {
            title: `${ctx.tableName} Request`,
            type: 'object',
            description: '',
            'x-internal': false,
            properties: {
                fields: {
                    type: 'object',
                    description: 'Record fields data to be created/updated',
                    properties: _extends({}, ((_ctx_columns1 = ctx.columns) == null ? void 0 : _ctx_columns1.reduce((colsObj, _1)=>{
                        let { title, virtual, column } = _1, fieldProps = _object_without_properties_loose(_1, [
                            "title",
                            "virtual",
                            "column"
                        ]);
                        var _column_meta;
                        return _extends({}, colsObj, virtual || (0, _nocodbsdk.isSystemColumn)(column) || column.ai || ((_column_meta = column.meta) == null ? void 0 : _column_meta.ag) ? {} : {
                            [title]: fieldProps
                        });
                    }, {})) || {})
                }
            },
            required: [
                'fields'
            ]
        },
        [`${(0, _stringHelpers.swaggerSanitizeSchemaName)(ctx.tableName)}UpdateRequest`]: {
            title: `${ctx.tableName} Update Request`,
            type: 'object',
            description: '',
            'x-internal': false,
            properties: {
                id: {
                    oneOf: [
                        {
                            type: 'string'
                        },
                        {
                            type: 'number'
                        }
                    ],
                    description: 'Record identifier (primary key value) for the record to be updated'
                },
                fields: {
                    type: 'object',
                    description: 'Record fields data to be updated',
                    properties: _extends({}, ((_ctx_columns2 = ctx.columns) == null ? void 0 : _ctx_columns2.reduce((colsObj, _1)=>{
                        let { title, virtual, column } = _1, fieldProps = _object_without_properties_loose(_1, [
                            "title",
                            "virtual",
                            "column"
                        ]);
                        var _column_meta;
                        return _extends({}, colsObj, virtual || (0, _nocodbsdk.isSystemColumn)(column) || column.ai || ((_column_meta = column.meta) == null ? void 0 : _column_meta.ag) ? {} : {
                            [title]: fieldProps
                        });
                    }, {})) || {})
                }
            },
            required: [
                'id',
                'fields'
            ]
        },
        [`${(0, _stringHelpers.swaggerSanitizeSchemaName)(ctx.tableName)}IdRequest`]: {
            title: `${ctx.tableName} Id Request`,
            type: 'object',
            description: '',
            'x-internal': false,
            properties: {
                id: {
                    oneOf: [
                        {
                            type: 'string'
                        },
                        {
                            type: 'number'
                        }
                    ],
                    description: 'Record identifier (primary key value) for the record to be deleted'
                }
            },
            required: [
                'id'
            ]
        }
    };
};
const getViewSchemas = (ctx)=>{
    var _ctx_columns, _ctx_columns1;
    return {
        [`${(0, _stringHelpers.swaggerSanitizeSchemaName)(ctx.tableName)}${(0, _stringHelpers.swaggerSanitizeSchemaName)(ctx.viewName)}GridResponse`]: {
            title: `${ctx.tableName} : ${ctx.viewName} Response`,
            type: 'object',
            description: '',
            'x-internal': false,
            properties: {
                id: {
                    oneOf: [
                        {
                            type: 'string'
                        },
                        {
                            type: 'number'
                        }
                    ],
                    description: 'Record identifier (primary key value)'
                },
                fields: {
                    type: 'object',
                    description: 'Record fields data from view',
                    properties: _extends({}, ((_ctx_columns = ctx.columns) == null ? void 0 : _ctx_columns.reduce((colsObj, _1)=>{
                        let { title, virtual, column } = _1, fieldProps = _object_without_properties_loose(_1, [
                            "title",
                            "virtual",
                            "column"
                        ]);
                        return _extends({}, colsObj, (0, _nocodbsdk.isSystemColumn)(column) || column.pk ? {} : {
                            [title]: fieldProps
                        });
                    }, {})) || {})
                }
            },
            required: [
                'id'
            ]
        },
        [`${(0, _stringHelpers.swaggerSanitizeSchemaName)(ctx.tableName)}${(0, _stringHelpers.swaggerSanitizeSchemaName)(ctx.viewName)}GridRequest`]: {
            title: `${ctx.tableName} : ${ctx.viewName} Request`,
            type: 'object',
            description: '',
            'x-internal': false,
            properties: {
                fields: {
                    type: 'object',
                    description: 'Record fields data for view-based operations',
                    properties: _extends({}, ((_ctx_columns1 = ctx.columns) == null ? void 0 : _ctx_columns1.reduce((colsObj, _1)=>{
                        let { title, virtual, column } = _1, fieldProps = _object_without_properties_loose(_1, [
                            "title",
                            "virtual",
                            "column"
                        ]);
                        return _extends({}, colsObj, virtual ? {} : {
                            [title]: fieldProps
                        });
                    }, {})) || {})
                }
            },
            required: [
                'fields'
            ]
        }
    };
};
